import type { Point } from "features/dt-basic-setup/single-building/model/types";

const EARTH_RADIUS_M = 6378137.0;
const DEG_TO_RAD = Math.PI / 180;

export const calculateOutlineAreaM2 = (outlinePoints: Point[]): number => {
  if (outlinePoints.length < 3) return 0;

  let area = 0;
  for (let i = 0; i < outlinePoints.length; i++) {
    const [lat1, lng1] = outlinePoints[i];
    const [lat2, lng2] = outlinePoints[(i + 1) % outlinePoints.length];
    area += (lng2 - lng1) * DEG_TO_RAD * (2 + Math.sin(lat1 * DEG_TO_RAD) + Math.sin(lat2 * DEG_TO_RAD));
  }
  return Math.abs((area * EARTH_RADIUS_M * EARTH_RADIUS_M) / 2.0);
};
